export const AUTHENTICATION_LOGIN = "AUTHENTICATION_LOGIN";
export const AUTHENTICATION_LOGOUT = "AUTHENTICATION_LOGOUT";
export const AUTHENTICATION_RENEW_TOKEN = "AUTHENTICATION_RENEW_TOKEN";
export const AUTHENTICATION_UPDATE_PROFILE = "AUTHENTICATION_UPDATE_PROFILE";

export const SET_UNREAD_CHAT = "SET_UNREAD_CHAT";
